import * as yup from "yup";

export const ROEWebValidationSchema = yup.object().shape({
  webProcessingMethod: yup
  .string()
  .required("Web Processing Method is required"),
  fileName: yup
  .string()
  .required("File name is required")
});
